import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ProductLineDto } from '../../models/product-line/product-line-dto';

@Injectable({
  providedIn: 'root'
})
export class ProductLineService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/productlines`;

  constructor(private readonly http: HttpClient) {}

  findAll(): Observable<ProductLineDto[]> {
    return this.http.get<ProductLineDto[]>(`${this.endpoint}`);
  }
}
